module.exports = __webpack_public_path__ + "img/bold-icon previous.c257c0a9.svg";